<script setup lang="ts">
const props = defineProps({
  tabs: { type: Array as PropType<{ title: string; link: string }[]>, required: true },
  active: { type: Number, required: true }
})

onMounted(() => {
  if (document) {
    const el = document.getElementById('forum-tabs') as HTMLElement
    scrollToTab(el, el, props.active, false)
  }
})
</script>

<template>
  <div id="forum-tabs" class="forum-tabs hide-scrollbar">
    <div
      v-for="(tab, i) in tabs"
      :key="`forum-tab-item-${i}`"
      :class="`tab-item clickable ${active === i ? 'tab-item-active' : ''}`"
      @click="navigateTo(tab.link)"
    >
      <span>{{ tab.title }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.forum-tabs {
  display: flex;
  /* gap: 45px; */
  /* border-bottom: 1px solid var(--borderL2); */
  gap: 40px;
}

.tab-item {
  /* padding-bottom: 10px; */
  padding-bottom: 7px;

  span {
    /* font-size: 0.9rem; */
    font-size: 0.87rem;
    font-weight: 500;
    color: var(--textM2);
  }
}

.tab-item-active {
  border-bottom: 2px solid var(--purple);

  span {
    color: var(--black);
  }
}

@media (max-width: 1000px) {
  .forum-tabs {
    margin-right: -50px;
    overflow-x: scroll;
  }
}

@media (max-width: 900px) {
  .forum-tabs {
    margin-right: -20px;
    margin-left: -20px;
    padding-right: 20px;
    padding-left: 20px;
  }
}
</style>
